var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8685 53.5L47.6228 64.2544L69.1315 42.7456M30.604 14.2304C34.4611 13.9226 38.1228 12.406 41.068 9.89643C44.396 7.05873 48.6264 5.5 53 5.5C57.3736 5.5 61.604 7.05873 64.932 9.89643C67.8772 12.406 71.5389 13.9226 75.396 14.2304C79.7555 14.5773 83.8488 16.4664 86.9412 19.5588C90.0336 22.6512 91.9227 26.7445 92.2696 31.104C92.5774 34.9611 94.094 38.6228 96.6036 41.568C99.4413 44.896 101 49.1264 101 53.5C101 57.8736 99.4413 62.104 96.6036 65.432C94.094 68.3772 92.5774 72.0389 92.2696 75.896C91.9227 80.2555 90.0336 84.3488 86.9412 87.4412C83.8488 90.5336 79.7555 92.4227 75.396 92.7696C71.5389 93.0774 67.8772 94.594 64.932 97.1036C61.604 99.9413 57.3736 101.5 53 101.5C48.6264 101.5 44.396 99.9413 41.068 97.1036C38.1228 94.594 34.4611 93.0774 30.604 92.7696C26.2445 92.4227 22.1512 90.5336 19.0588 87.4412C15.9664 84.3488 14.0773 80.2555 13.7304 75.896C13.4226 72.0389 11.906 68.3772 9.39643 65.432C6.55873 62.104 5 57.8736 5 53.5C5 49.1264 6.55873 44.896 9.39643 41.568C11.906 38.6228 13.4226 34.9611 13.7304 31.104C14.0773 26.7445 15.9664 22.6512 19.0588 19.5588C22.1512 16.4664 26.2445 14.5773 30.604 14.2304Z",
    stroke: "#5C1628",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.efab9c74c669517b327be6d00398b8b8.svg";
export { ForwardRef as ReactComponent };